module.exports = __webpack_public_path__ + "img/SensorCase.85cff278.webp";